import React from 'react';
import { Helmet } from 'react-helmet';
import './LandingPage.css'; // Import the CSS file for styling
import exampleImage from '../assets/mailattach-main-image.png'; // Replace with your actual image path
import alertImage from '../assets/mailattach-alert.png';
import gmailIcon from '../assets/gmail-icon.png'; // Import the Gmail icon image

const LandingPage = () => {
    return (
        <div className="landing-page">
            <Helmet>
                <title>MailAttach - Detects missing attachments in Gmail</title>
                <meta
                    name="description"
                    content="The Chrome Extension which detects missing attachments and blocks the email from sending."
                />
            </Helmet>
            <div className="content hero-content">
                <div className="text-section">
                    <h1>Detects missing attachments in Gmail</h1>
                    <p style={{color: "grey", fontSize: 20}}>MailAttach is a chrome extension which detects missing attachments and prevents the email from being sent without them. {<br/>}{<br/>}Works in all languages.</p>
                    <a
                        href="https://chromewebstore.google.com/detail/mailattach-ai-powered-mis/oncbebpmgkclejkfcolooflnniokmmka" // Replace with your actual Chrome Web Store URL
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={gmailIcon} alt="Gmail Icon" className="gmail-icon" /> Add to Gmail in Chrome now
                    </a>
                    {/*<span>Only on web. Not available on mobile at the moment.</span>*/}
                </div>
                <div className="image-section">
                    <div className="preview-wrap">
                        <img src={exampleImage} alt="MailAttach Preview" className="preview-image" />
                        <div className="status-callout" aria-hidden="true">
                            <span className="status-callout-intro">You type your email.</span>
                            <span className="status-callout-message">
                                <span className="status-callout-dot" />
                                MailAttach works in the background.
                            </span>
                        </div>
                        <svg
                            className="status-arrow"
                            viewBox="0 0 1194 1222"
                            preserveAspectRatio="none"
                            aria-hidden="true"
                        >
                            <defs>
                                <marker
                                    id="status-arrow-head"
                                    markerWidth="13"
                                    markerHeight="13"
                                    refX="10"
                                    refY="6"
                                    orient="auto"
                                >
                                    <path d="M 0 0 L 12 6 L 0 12 z" fill="#16803f" />
                                </marker>
                            </defs>
                            <path
                                d="M 930 190 C 760 120, 590 86, 435 52"
                                fill="none"
                                stroke="#16803f"
                                strokeWidth="10"
                                strokeLinecap="round"
                                markerEnd="url(#status-arrow-head)"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <section className="alert-section" aria-labelledby="alert-section-title">
                <div className="alert-copy">
                    <span className="section-label">Before it sends</span>
                    <h2 id="alert-section-title">One last check, right when you need it.</h2>
                    <p>
                        Mention an attachment without adding one and MailAttach pauses the first send,
                        giving you a moment to double-check.
                    </p>
                </div>
                <div className="alert-image-frame">
                    <img
                        src={alertImage}
                        alt="MailAttach alert warning that an attachment was mentioned but not found"
                        className="alert-image"
                    />
                </div>
            </section>
        </div>
    );
};

export default LandingPage;
